import { bulkConfigurationApiUrl } from "../../bulkBaseUrl";

export const dimensionsUrl = `${bulkConfigurationApiUrl}/dimensions`;

/** Key for identifying and caching {@link https://react-query.tanstack.com/overview react-query} requests */
export const dimensionsKey = "dimensions";